<template>
    <div class="test-set">
        <el-row class="set-header">
            <el-col :span="4">
                试卷设置
                <span>(试卷库出题)</span>
            </el-col>
            <el-col :span="4" :offset="16">
                <el-button type="text" style="float:right" @click="open=!open">选择试卷</el-button>
            </el-col>
        </el-row>
        <div>
            <el-table
                style="width: 100%"
                :data="tableData"
                :header-cell-style="{
                        textAlign:'center',
                        backgroundColor:'#f5f5f6'
                    }"
                :cell-style="{
                        textAlign: 'center'
                    }"
            >
                <el-table-column label="题型">
                    <template slot-scope="scope">
                        <span>{{questionTypes[scope.row.id]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="题数">
                    <template slot-scope="scope">
                        <span>{{scope.row.list.length}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="单题分(均值)">
                    <template slot-scope="scope">
                        <span>{{scope.row.totalScore / scope.row.list.length}}分/道</span>
                    </template>
                </el-table-column>
                <el-table-column label="总分">
                    <template slot-scope="scope">
                        <span>{{scope.row.totalScore}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-row style="margin-top:20px">
            <el-col :span="4" :offset="20">
                <el-button @click="previousStep">上一步</el-button>
                <el-button type="primary" @click="nextStep">下一步</el-button>
            </el-col>
        </el-row>
        <el-dialog title="试卷选择" :visible.sync="open" width="900px">
            <el-row>
                <el-col>注:仅能选择试卷库中已发布的试卷</el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top:20px">
                <el-col :span="6" v-for="(item, index) in etexampaperList" :key="item.id">
                    <div
                        class="test-choose"
                        :class="{ 'active': index === curPaper }"
                        @click="handleClick(index)"
                    >
                        <h3>
                            <span v-text="`#${item.id}`"></span>&nbsp;
                            <span v-text="item.name"></span>
                        </h3>
                        <p v-text="item.createTime"></p>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import { getEtexampapers, getEtexampaperDetail } from '@/api/exam/etexampaper'
import { getEtquestiontypeList } from '@/api/exam/etquestiontype'
import { formatQuestions } from '@/utils/exam'
export default {
    data () {
        return {
            curPaper: 0, // 当前选中的试卷
            questionTypes: {}, // 题目类型
            open: false,
            tableData: [],
            // 试卷列表
            etexampaperList: []
        };
    },
    watch: {
        '$route' (to) {
            if (to.path == '/test/newTest/add/creat') {
                this.$router.go(0)
            }
        }
    },
    methods: {
        init () {
            this.getQuestionTypes()
            this.getPapers()
        },
        // 获取所有试卷
        getPapers () {
            getEtexampapers().then(res => {
                this.etexampaperList = res
                this.getPaperInfo(res[0].id)
            })
        },
        // 获取题目类型
        getQuestionTypes () {
            getEtquestiontypeList().then(res => {
                let questionTypes = {}
                res.map(type => {
                    questionTypes[type.id] = type.name
                })
                this.questionTypes = questionTypes
            })
        },
        // 获取试卷详情
        getPaperInfo (paperId) {
            getEtexampaperDetail(paperId).then(res => {
                let { content } = res
                let questions = []
                let oQuestions = {}
                let arrQuestions = []
                if (content) {
                    questions = formatQuestions(content)
                }
                Object.keys(this.questionTypes).forEach(key => {
                    oQuestions[key] = {
                        list: [],
                        totalScore: 0
                    }
                });
                questions.map(question => {
                    oQuestions[question.questionTypeId].list.push(question)
                    oQuestions[question.questionTypeId].totalScore += question.questionPoint
                })
                Object.keys(oQuestions).forEach(key => {
                    if (oQuestions[key].list.length > 0) {
                        arrQuestions.push({
                            id: key,
                            ...oQuestions[key]
                        })
                    }
                });
                this.tableData = arrQuestions
            })
        },
        nextStep () {
            const { id } = this.etexampaperList[this.curPaper]
            if (id) {
                this.$emit("submit", { examPaperId: id });
            }
        },
        previousStep () {
            this.$router.go(-1)
        },
        handleClick (index) {
            this.curPaper = index
            this.getPaperInfo(this.etexampaperList[index].id)
        }
    },
    created () {
        this.init()
    }
};
</script>
<style lang="less">
.test-set {
    .el-dialog__header {
        border-bottom: 1px solid #dcdcdc;
    }
    .el-dialog__footer {
        padding: 20px;
        border-top: 1px solid #dcdcdc;
    }
}
</style>

<style lang="less" scoped>
.test-set {
    .set-header {
        margin: 20px 0;
        padding: 0 10px;
        line-height: 40px;
        border-bottom: 1px solid #dcdcdc;
    }
    .test-choose {
        position: relative;
        padding: 10px;
        min-height: 80px;
        border: 1px solid #ccc;
        border-radius: 5px;
        p {
            margin-top: 10px;
        }
    }
    .active {
        color: #09a258;
        background-color: #e2f9ee;
        border: 1px #09a258 solid;
        ::before {
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            width: 20px;
            height: 24px;
            background-image: url('~@/assets/imgs/gou.png');
        }
    }
}
</style>

